import { render, staticRenderFns } from "./CelebrationsReport.vue?vue&type=template&id=45903c74"
import script from "./CelebrationsReport.vue?vue&type=script&lang=js"
export * from "./CelebrationsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports